import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = {
  class: "modal-header",
  id: "kt_modal_new_address_header"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("h2", null, "Renew Coverage", -1)
const _hoisted_5 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_8 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_new_address_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_new_address_header",
  "data-kt-scroll-wrappers": "#kt_modal_new_address_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_9 = { class: "notice d-flex bg-light-warning rounded border-warning border border-dashed mb-9 p-6" }
const _hoisted_10 = { class: "svg-icon svg-icon-2tx svg-icon-warning me-4" }
const _hoisted_11 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_12 = { class: "fw-bold" }
const _hoisted_13 = /*#__PURE__*/_createVNode("h4", { class: "text-gray-800 fw-bolder" }, "Confirmation", -1)
const _hoisted_14 = { class: "fs-6 text-gray-600" }
const _hoisted_15 = /*#__PURE__*/_createVNode("a", { href: "#/dashboard/coveragelist" }, "Available Coverages", -1)
const _hoisted_16 = { class: "row mb-5" }
const _hoisted_17 = { class: "col-md-6 fv-row" }
const _hoisted_18 = /*#__PURE__*/_createVNode("label", { class: "required fs-5 fw-bold mb-2" }, "First name", -1)
const _hoisted_19 = { class: "fv-plugins-message-container" }
const _hoisted_20 = { class: "fv-help-block" }
const _hoisted_21 = { class: "col-md-6 fv-row" }
const _hoisted_22 = /*#__PURE__*/_createVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Middle name", -1)
const _hoisted_23 = { class: "fv-plugins-message-container" }
const _hoisted_24 = { class: "fv-help-block" }
const _hoisted_25 = { class: "row mb-5" }
const _hoisted_26 = { class: "col-md-6 fv-row" }
const _hoisted_27 = /*#__PURE__*/_createVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Last name", -1)
const _hoisted_28 = { class: "fv-plugins-message-container" }
const _hoisted_29 = { class: "fv-help-block" }
const _hoisted_30 = { class: "col-md-6 fv-row" }
const _hoisted_31 = /*#__PURE__*/_createVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Birth Date", -1)
const _hoisted_32 = { class: "fv-plugins-message-container" }
const _hoisted_33 = { class: "fv-help-block" }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "fv-row mb-5" }, [
  /*#__PURE__*/_createVNode("div", { class: "d-flex flex-stack" }, [
    /*#__PURE__*/_createVNode("div", { class: "me-5" }, [
      /*#__PURE__*/_createVNode("label", { class: "fs-5 fw-bold" }, "Your coverage beneficiary"),
      /*#__PURE__*/_createVNode("div", { class: "fs-7 fw-bold text-gray-400" })
    ])
  ])
], -1)
const _hoisted_35 = { class: "row mb-5" }
const _hoisted_36 = { class: "col-md-6 fv-row" }
const _hoisted_37 = /*#__PURE__*/_createVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Beneficiary First name", -1)
const _hoisted_38 = { class: "fv-plugins-message-container" }
const _hoisted_39 = { class: "fv-help-block" }
const _hoisted_40 = { class: "col-md-6 fv-row" }
const _hoisted_41 = /*#__PURE__*/_createVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Beneficiary Middle Name", -1)
const _hoisted_42 = { class: "fv-plugins-message-container" }
const _hoisted_43 = { class: "fv-help-block" }
const _hoisted_44 = { class: "row mb-5" }
const _hoisted_45 = { class: "col-md-6 fv-row" }
const _hoisted_46 = /*#__PURE__*/_createVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Beneficiary Last name", -1)
const _hoisted_47 = { class: "fv-plugins-message-container" }
const _hoisted_48 = { class: "fv-help-block" }
const _hoisted_49 = { class: "col-md-6 fv-row" }
const _hoisted_50 = /*#__PURE__*/_createVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Beneficiary Birth Date", -1)
const _hoisted_51 = { class: "fv-plugins-message-container" }
const _hoisted_52 = { class: "fv-help-block" }
const _hoisted_53 = { class: "row mb-5" }
const _hoisted_54 = { class: "col-md-6 fv-row" }
const _hoisted_55 = /*#__PURE__*/_createVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Beneficiary Contact", -1)
const _hoisted_56 = { class: "fv-plugins-message-container" }
const _hoisted_57 = { class: "fv-help-block" }
const _hoisted_58 = { class: "col-md-6 fv-row" }
const _hoisted_59 = /*#__PURE__*/_createVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Beneficiary Relationship", -1)
const _hoisted_60 = /*#__PURE__*/_createVNode("option", null, "Select Relationship", -1)
const _hoisted_61 = /*#__PURE__*/_createVNode("option", {
  label: "Spouse",
  value: "Spouse"
}, "Spouse", -1)
const _hoisted_62 = /*#__PURE__*/_createVNode("option", {
  label: "Child",
  value: "Child"
}, "Child", -1)
const _hoisted_63 = /*#__PURE__*/_createVNode("option", {
  label: "Parent",
  value: "Parent"
}, "Parent", -1)
const _hoisted_64 = /*#__PURE__*/_createVNode("option", {
  label: "Sibling",
  value: "Sibling"
}, "Sibling", -1)
const _hoisted_65 = /*#__PURE__*/_createVNode("option", {
  label: "Others (Blood-related, Relative)",
  value: "Others"
}, "Others (Blood-related, Relative)", -1)
const _hoisted_66 = { class: "fv-plugins-message-container" }
const _hoisted_67 = { class: "fv-help-block" }
const _hoisted_68 = { class: "modal-footer flex-center" }
const _hoisted_69 = {
  key: 0,
  ref: "submitButtonRef",
  type: "button",
  id: "kt_modal_new_address_submit",
  class: "btn btn-primary"
}
const _hoisted_70 = { key: 1 }
const _hoisted_71 = /*#__PURE__*/_createTextVNode(" Please wait... ")
const _hoisted_72 = /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_Field = _resolveComponent("Field")
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")
  const _component_Form = _resolveComponent("Form")

  return (_openBlock(), _createBlock("div", {
    class: "modal fade",
    id: _ctx.sealpro_encode_modal,
    tabindex: "-1",
    "aria-hidden": "true"
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_Form, {
          class: "form",
          id: "kt_modal_new_address_form",
          onSubmit: _ctx.submit,
          "validation-schema": _ctx.validationSchema
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode("div", _hoisted_5, [
                _createVNode("span", _hoisted_6, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Close.svg" })
                ])
              ])
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, [
                  _createVNode("span", _hoisted_10, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Warning-1-circle.svg" })
                  ]),
                  _createVNode("div", _hoisted_11, [
                    _createVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createVNode("div", _hoisted_14, [
                        _createTextVNode(" This will consume a " + _toDisplayString(_ctx.sealproPlan) + " coverage from your ", 1),
                        _hoisted_15
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_16, [
                  _createVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control form-control-solid",
                      placeholder: "",
                      name: "insured_firstName",
                      modelValue: _ctx.insured_firstName,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.insured_firstName = $event)),
                      disabled: "true"
                    }, null, 8, ["modelValue"]),
                    _createVNode("div", _hoisted_19, [
                      _createVNode("div", _hoisted_20, [
                        _createVNode(_component_ErrorMessage, { name: "firstName" })
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control form-control-solid",
                      placeholder: "",
                      name: "insured_middleName",
                      modelValue: _ctx.insured_middleName,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.insured_middleName = $event)),
                      disabled: "true"
                    }, null, 8, ["modelValue"]),
                    _createVNode("div", _hoisted_23, [
                      _createVNode("div", _hoisted_24, [
                        _createVNode(_component_ErrorMessage, { name: "lastName" })
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_25, [
                  _createVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control form-control-solid",
                      placeholder: "",
                      name: "insured_lastName",
                      modelValue: _ctx.insured_lastName,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.insured_lastName = $event)),
                      disabled: "true"
                    }, null, 8, ["modelValue"]),
                    _createVNode("div", _hoisted_28, [
                      _createVNode("div", _hoisted_29, [
                        _createVNode(_component_ErrorMessage, { name: "firstName" })
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control form-control-solid",
                      placeholder: "",
                      name: "insured_birthday",
                      modelValue: _ctx.insured_birthday,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.insured_birthday = $event)),
                      disabled: "true"
                    }, null, 8, ["modelValue"]),
                    _createVNode("div", _hoisted_32, [
                      _createVNode("div", _hoisted_33, [
                        _createVNode(_component_ErrorMessage, { name: "insured_birthday" })
                      ])
                    ])
                  ])
                ]),
                _hoisted_34,
                _createVNode("div", _hoisted_35, [
                  _createVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control form-control-solid",
                      placeholder: "",
                      name: "beneficiary_firstName",
                      modelValue: _ctx.beneficiary_firstName,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.beneficiary_firstName = $event)),
                      maxlength: "50",
                      disabled: "true"
                    }, null, 8, ["modelValue"]),
                    _createVNode("div", _hoisted_38, [
                      _createVNode("div", _hoisted_39, [
                        _createVNode(_component_ErrorMessage, { name: "beneficiary_firstName" })
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_40, [
                    _hoisted_41,
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control form-control-solid",
                      placeholder: "",
                      name: "beneficiary_middleName",
                      modelValue: _ctx.beneficiary_middleName,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.beneficiary_middleName = $event)),
                      maxlength: "50",
                      disabled: "true"
                    }, null, 8, ["modelValue"]),
                    _createVNode("div", _hoisted_42, [
                      _createVNode("div", _hoisted_43, [
                        _createVNode(_component_ErrorMessage, { name: "beneficiary_middleName" })
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_44, [
                  _createVNode("div", _hoisted_45, [
                    _hoisted_46,
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control form-control-solid",
                      placeholder: "",
                      name: "beneficiary_lastName",
                      modelValue: _ctx.beneficiary_lastName,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.beneficiary_lastName = $event)),
                      maxlength: "50",
                      disabled: "true"
                    }, null, 8, ["modelValue"]),
                    _createVNode("div", _hoisted_47, [
                      _createVNode("div", _hoisted_48, [
                        _createVNode(_component_ErrorMessage, { name: "beneficiary_lastName" })
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_49, [
                    _hoisted_50,
                    _createVNode(_component_Field, {
                      type: "date",
                      class: "form-control form-control-solid",
                      placeholder: "",
                      name: "beneficiary_birthday",
                      modelValue: _ctx.beneficiary_birthday,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.beneficiary_birthday = $event)),
                      disabled: "true"
                    }, null, 8, ["modelValue"]),
                    _createVNode("div", _hoisted_51, [
                      _createVNode("div", _hoisted_52, [
                        _createVNode(_component_ErrorMessage, { name: "beneficiary_birthday" })
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_53, [
                  _createVNode("div", _hoisted_54, [
                    _hoisted_55,
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control form-control-solid",
                      placeholder: "",
                      name: "beneficiary_contact",
                      modelValue: _ctx.beneficiary_contact,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.beneficiary_contact = $event)),
                      maxlength: "20",
                      disabled: "true"
                    }, null, 8, ["modelValue"]),
                    _createVNode("div", _hoisted_56, [
                      _createVNode("div", _hoisted_57, [
                        _createVNode(_component_ErrorMessage, { name: "beneficiary_contact" })
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_58, [
                    _hoisted_59,
                    _createVNode(_component_Field, {
                      name: "beneficiary_relationship",
                      class: "form-select form-select-solid",
                      as: "select",
                      modelValue: _ctx.beneficiary_relationship,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.beneficiary_relationship = $event)),
                      disabled: "true"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_60,
                        _hoisted_61,
                        _hoisted_62,
                        _hoisted_63,
                        _hoisted_64,
                        _hoisted_65
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode("div", _hoisted_66, [
                      _createVNode("div", _hoisted_67, [
                        _createVNode(_component_ErrorMessage, { name: "beneficiary_relationship" })
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_68, [
              (_ctx.coi !== undefined && _ctx.coi !== '')
                ? (_openBlock(), _createBlock("button", _hoisted_69, [
                    (!_ctx.issubmitting)
                      ? (_openBlock(), _createBlock("span", {
                          key: 0,
                          class: "indicator-label",
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.submitRenewal()))
                        }, " Submit Renewal "))
                      : (_openBlock(), _createBlock("span", _hoisted_70, [
                          _hoisted_71,
                          _hoisted_72
                        ]))
                  ], 512))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ])
  ], 8, ["id"]))
}